class MoneyExchangeRateRange {
    public fromValue: number;
    public toValue: number;
    public value: number;

    constructor(fromValue: number, toValue: number, value: number) {
        this.fromValue = fromValue;
        this.toValue = toValue;
        this.value = value;
    }
}

export default MoneyExchangeRateRange;